<template>
  <div class="container col-md-8 mt-md-5 p-4">
    <div class="row">
      <h2 class="text-uppercase">{{ $t('login.title') }}</h2>
    </div>
    <form @submit.prevent="login" class="row">
      <div class="col-12 my-2 grid-layout">
        <label for="username">{{ $t('login.email') }}</label>
        <input type="username" class="p-1" v-model="username" required />
      </div>
      <div class="col-12 my-2 grid-layout">
        <label for="password">{{ $t('login.password') }}</label>
        <input type="password" class="p-1" v-model="password" required />
      </div>
      <button class="col-12 btn btn-bb5-yellow w-25" type="submit">{{ $t('login.button') }}</button>
    </form>
    <p v-if="error">{{ $t('login.error') }}</p>
  </div>
</template>


<script>
import authService from '../services/authService';

export default {
  data() {
    return {
      username: '',
      password: '',
      error: null
    };
  },
  methods: {
    async login() {
      try {
        await authService.login({
          username: this.username,
          password: this.password
        });
        // this.$store.dispatch('setIsLoggedIn', true);
        // this.$router.push('/dashboard'); // example redirect
      } catch (err) {
        this.error = 'Login failed. Please check your credentials.';
      }
    }
  }
};
</script>

<style scoped>
.grid-layout {
  display: grid;
  grid-template-columns: 1fr auto; /* Label und Input nehmen den verfügbaren Platz ein */
  align-items: center; /* Zentriere vertikal */
  position: relative;
}
</style>
